import React, { useState } from "react";
import "../css/appStyling.css";
import axios from "axios";
import BackToHome from "./BackToHome";
function Weatherman() {
  // document.title = 'WeatherManApp - Check weather info in your area | G Rohit';
  let userInput;
  const apiKey = process.env.REACT_APP_WEATHER_MAN_APP_ID;
  
  // for weather info
  let [weatherFullInfo, setWeatherFullInfo] = useState(null);
  // for error msgs
  let [error, setError] = useState(null);
  // for setting bg images
  const [bgImageClass, setBgImageClass] = useState("");
 

  // let weatherFullInfo = {};
  const fetchWeatherInfo = async () => {
    userInput = document.getElementById("userInputZip").value;
    console.log(userInput);
    try {
      const responseData = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?zip=${userInput},IN&APPID=${apiKey}&units=metric`
      );
      // console.log(`https://api.openweathermap.org/data/2.5/weather?zip=${userInput}IN&APPID=${myAPI}&units=metric`);
      // console.log(responseData.status);
      // console.log(responseData);
      // console.log("weatherInfo is: ", weatherInfo);
      if (responseData.data) {
        // console.log("responseData.data: ");
        // console.log(responseData.data);
        weatherFullInfo = {
          date: responseData.data.dt,
          name: responseData.data.name,
          feels_like: responseData.data.main.feels_like,
          max_temp: responseData.data.main.temp_max,
          min_temp: responseData.data.main.temp_min,
          sunrise: responseData.data.sys.sunrise,
          sunset: responseData.data.sys.sunset,
          weatherConditionMain: responseData.data.weather[0].main,
          weatherCondition: responseData.data.weather[0].description,
          icon: responseData.data.weather[0].icon,
        };

        setWeatherFullInfo(weatherFullInfo); // Update state with data
        setError("");

        //  set the bg as per the weatherConditionMain:

        let WCmain = weatherFullInfo.weatherConditionMain.toLowerCase();

        // console.log("WCmain: ", WCmain);
 

        switch (WCmain) {
          case "mist":
            setBgImageClass("bg-mist");
            break;
          case "thunderstorm":
            setBgImageClass("bg-thunderstorm");
            break;
          case "clear":
            setBgImageClass("bg-clear");
            break;
          case "clouds":
            setBgImageClass("bg-clouds");
            break;
          case "rain":
            setBgImageClass("bg-rain");
            break;
          case "haze":
            setBgImageClass("bg-haze");
            break;
          case "snow":
            setBgImageClass("bg-snow");
            break;
          default:
            setBgImageClass("");
            break;
        }

        // if (WCmain=== "rain") {
        //   setBgImageClass("../../src/Assets/weatherman/bg-rain.webp")

        // }

        // console.log("weatherFullInfo is UPDATED to: ", weatherFullInfo);
      } else {
        console.log("waiting for data");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log("error is: ", error.response.data.message);
        setError(
          `City with Zipcode: ${userInput} is not valid. Please enter a valid Zip Code.`
        );
      } else if (error.response && error.response.status === 400) {
        setError("Please enter a valid Zip Code.");
      }
    }
    // console.log(weatherFullInfo, 'is global');
    // return weatherFullInfo;
  };

  // function to convery epoc time to local time
  function convertToLocalTime(epoc) {
    // Your Unix timestamp (in seconds)
    const unixTimestamp = epoc;

    // Convert the Unix timestamp to milliseconds
    const timestampInMilliseconds = unixTimestamp * 1000;

    // Create a Date object from the timestamp
    const date = new Date(timestampInMilliseconds);

    // Get the local date and time
    const localDateTime = date.toLocaleString();

    // console.log('localDateTime: ', localDateTime);
    return localDateTime;
  }
  return (
    <>
      <div
        className={`weatherman-container ${bgImageClass}`}
        id="weather-section"
      >
        <h1 style={{marginTop: "0",}} className="text-center">WeatherManApp</h1>
        <h3 style={{textAlign: "center" ,}} className="my-3">
          Howdie, Check the weather in your area right now!!
        </h3>

        <div className="input-container">
          <input
            type="tel"
            placeholder="Enter the zipcode of your area"
            id="userInputZip"
          />
          <button className="weatherman-btn" onClick={fetchWeatherInfo}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 66 66"
              fill="none"
            >
              <path
                d="M11 30.2502V35.7502H44L28.875 50.8752L32.78 54.7802L54.56 33.0002L32.78 11.2202L28.875 15.1252L44 30.2502H11Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
        {error ? (
          <>
            <p className="errorMessage">{ error }</p>
          </>
        ) : (
          <></>
        )}
        {weatherFullInfo ? (
          <>
            <div className="output-data">
              <h5>
                Showing Information for Date:{" "}
                {convertToLocalTime(weatherFullInfo.date)}
              </h5>
              <ul>
                <li>
                  <span className="weatherAttribute">Location:</span>
                  <span className="weatherValue">{weatherFullInfo.name}</span>
                </li>
                <li>
                  <span className="weatherAttribute">Feels Like:</span>
                  <span
                    className="weatherValue"
                    style={{ fontSize: "2em" }}
                  >{`${weatherFullInfo.feels_like} \u2103`}</span>
                </li>

                <li>
                  <span className="weatherAttribute">Max Temp:</span>
                  <span className="weatherValue">
                    {`${weatherFullInfo.max_temp} \u2103`}
                  </span>
                </li>
                <li>
                  <span className="weatherAttribute">Min Temp:</span>
                  <span className="weatherValue">
                    {`${weatherFullInfo.min_temp} \u2103`}
                  </span>
                </li>
                <li>
                  <span className="weatherAttribute">Sunrise:</span>
                  <span className="weatherValue">
                    {`${convertToLocalTime(weatherFullInfo.sunrise)}`}
                  </span>
                </li>
                <li>
                  <span className="weatherAttribute">Sunset:</span>
                  <span className="weatherValue">
                    {`${convertToLocalTime(weatherFullInfo.sunset)}`}
                  </span>
                </li>
                <li>
                  <span className="weatherAttribute">Condition:</span>
                  <span className="weatherValue">
                    {weatherFullInfo.weatherConditionMain}
                  </span>
                </li>
                <li>
                  <span className="weatherAttribute">Description:</span>
                  <span className="weatherValue">
                    {weatherFullInfo.weatherCondition}{" "}
                    <img
                      src={`http://openweathermap.org/img/wn/${weatherFullInfo.icon}.png`}
                      style={{ maxWidth: "30px", verticalAlign: "middle" }}
                      alt="icon"
                    />
                  </span>
                </li>
              </ul>
            </div>
          </>
        ) : (
          <h5 className="text-center my-3">Enter the zipcode and hit &#8594;</h5>
        )}
      </div>
      <BackToHome/>
    </>
  );
}
export default Weatherman;
